<template>
  <menu class="siteMenu" v-bind:class="{ siteMenuUseMovile: useAutoHideForMobile }">
    <nav v-bind:class='{active:show}'>
      <ul>
        <li><router-link to="/">HOME</router-link></li>
        <li><router-link to="/games">GAMES</router-link></li>
        <li><router-link to="/tools">TOOLS</router-link></li>
        <li><a href='https://ci-en.net/creator/16060'>Ci-en</a></li>
        <!-- <li><router-link to="/contact">CONTACT</router-link></li> -->
        <li><a href='http://alphastella07ks.blog.shinobi.jp/'>BLOG(旧)</a></li>
      </ul>
      <a href="https://twitter.com/K_Shin07" target="_blank">
        <i class="fab fa-twitter fa-2x fa-fw twitter-icon"></i>
      </a>
      <a href="https://www.youtube.com/@K_Shin07" target="_blank">
        <i class="fab fa-youtube-square fa-2x fa-fw youtube-icon"></i>
      </a>
    </nav>
  </menu>
</template>

<script>
export default {
  props: ['useAutoHideForMobile'],
  data () {
    return {
      show: false
    }
  }
}
</script>

<style scoped lang="scss">
@import './../styles/definitions.scss';
.siteMenu {
  height: 100vh;
  width: $MenuWidth;
  box-sizing:border-box;
  position: fixed;
  background-color: $kMenuColorMain;
  background-image: url(../assets/pattern_00.png);
  float: left;
  z-index: $kZIndexMenu;
  box-shadow: 8px 0 4px -2px rgba(0,0,0,0.1);
  transition: .14s ease-out;
}

nav {
  transition: .14s ease-out;
  ul {
    padding: 0;
    li {
      list-style-type: none;
      box-sizing: border-box;
      border-top: 2px solid rgba(0, 0, 0, 0.2);
      border-bottom: 2px solid rgba(255, 255, 255, 0.2);
      position: relative;
      transition: 0.3s;

      &:hover {
        background-color: #ffffff;
      }

      a {
        color: #2B6CA3;
        font-size: 30px;
        font-weight: bold;
        box-sizing: border-box;
        padding: 5px 32px;
        display: block;
        text-decoration: none;
        transition: 0.2s;
        &:hover {
          color: rgb(43, 148, 235);
        }
      }
    }
  }
}

.twitter-icon {
  color: #dddddd;
  &:hover {
    color: #ffffff;
  }
}

.youtube-icon {
  color: #dddddd;
  &:hover {
    color: #ffffff;
  }
}

@media (max-width: $MobileWidth) {
  .siteMenuUseMovile {
    width: 0%;
    background-color: rgba(0,0,0,0);
    transition: .14s ease-out;
    box-shadow: 0;
  }
  .siteMenuUseMovile nav {
    width: 0%;
    overflow: hidden;
    opacity: 0;
    transition: .14s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SiteMenu.vue